export default {
  root: {
    class: 'flex flex-col gap-8',
  },
};
